import { HttpErrorResponse } from "@angular/common/http";

import { ApiResponse, ApiResponseError } from "@lib/types";

export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again.";

function toMessages(value: unknown): string[] {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed ? [trimmed] : [];
  }

  if (Array.isArray(value)) {
    return value.flatMap((entry) => toMessages(entry));
  }
  
  return [];
}

export function getErrorMessages(error: unknown): string[] {
  if (error instanceof ApiResponseError) {
    const errors = toMessages(error.errors);
    return errors.length ? errors : toMessages(error.message);
  }

  if (error instanceof HttpErrorResponse) {
    if (!error.error || typeof error.error !== "object") return [];

    const body = error.error as Partial<ApiResponse<unknown>>;
    const errors = toMessages(body.errors);

    return errors.length ? errors : toMessages(body.message);
  }

  return [];
}

export function getErrorMessage(
  error: unknown,
  fallback: string = GENERIC_ERROR_MESSAGE,
): string {
  const messages = getErrorMessages(error);
  return messages.length ? messages.join("\n") : fallback;
}
